export default [
    {
        path: 'photo-guide',
        name: 'photo-guide',
        component: () => import('@/views/photo-guide/Index'),
        meta: {
            nextable: true
        }
    },
]